//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clickToBack } from "@/common/js/util";
export default {
  data() {
    return {
      listShow: false,
      boxshow: true
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "relative",
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
    styleObject: {
      type: Object,
      default: function () {
        return {};
      },
    },
    notShowBack: {
      type: Boolean,
      default: false,
    },
    mobileType: {
      type: String,
      default: "h5",
    },
  },
  mounted(){
    if(window.navigator.userAgent.indexOf('appxhjyjt_')!=-1){ //在app里
      this.boxshow = false
    }
  },
  methods: {
    clickBack() {
      if (this.mobileType != "h5" || window.navigator.userAgent.indexOf('appxhjyjt_')!=-1) {
        if(window.history.length >= 2){
          this.$router.go(-1)
        }else{
          try {
            if (/android/i.test(window.navigator.userAgent)) {
              AppUtil.redirect("historyback");
            } else if (/iphone/i.test(window.navigator.userAgent)) {
              window.webkit.messageHandlers.redirect.postMessage({
                "type": "historyback",
              });
            }
          } catch (e) {
            console.log(e);
          }
        }

      } else {
        console.log(this.$route);
        if (this.$route.name == "login" && this.$route.query.from == "/Learn") {
          this.$router.push("/");
          return;
        }
        clickToBack(this);
        // window.history.length >= 2
        // ? this.$router.go(-1)
        // : this.$router.push('/')
      }
    },
    clickRouter(data) {
      console.log(data);
      this.$router.push(data);
    },
    clickList() {
      this.listShow = !this.listShow;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/headerBack.vue